import ahsanSajidImage from "@/assets/ahsan-sajid.png";

export const ApiSecurityFounderQuote = () => {
  return (
    <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <img
          src={ahsanSajidImage}
          alt="Ahsan Sajid"
          className="w-14 h-14 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-foreground italic leading-relaxed">
            "Every project should go through a security checklist before deployment. I've seen what happens 
            when APIs get compromised — it's not just data loss, it's lost trust and lost business. Treat 
            API security like insurance: you pay upfront, or you pay much more later."
          </blockquote>
          <div className="mt-4">
            <p className="font-semibold text-foreground">Ahsan Sajid</p>
            <p className="text-sm text-muted-foreground">Owner, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
